// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

import moment from 'moment';
import dayjs from 'dayjs';
import duration from "dayjs/plugin/duration";
global.moment = moment;
global.ClipboardJS = require('./clipboard');
dayjs.extend(duration);
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
function startCountDown() {
  var endTime = dayjs().add(5, 'm');
  $('#auto-status-bar').text('');
  var timer = setInterval(function() {
    var now = dayjs();
    var counter = dayjs.duration(endTime.diff(now));
    var hours = counter.hours();
    var min = counter.minutes();
    var sec = counter.seconds();
    var overtime = hours < 0 || min < 0 || sec < 0;
    if (overtime) {
      $('.countdown-text').html('FedEx Refund request in progress...')
      clearInterval(timer);
    }
    
    if(hours == 0) {
      if (sec < 10) sec = '0' + sec;
      $('.countdown-text').html(min + ':' + sec + ' until we restart');
    } else {
      if (min < 10) min = '0' + min;
      if (sec < 10) sec = '0' + sec;
      $('.countdown-text').html(hours + ':' + min + ':' + sec + ' until we restart');
    }
  }, 1000);
  return endTime;
}

global.startCountDown = startCountDown;